/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BindingTargetEsercente } from './binding-target-esercente';
import { UiWidget } from './ui-widget';


export interface TipoPraticaAttributoEsercenteListFilter { 
    binding?: BindingTargetEsercente;
    ui_widget?: UiWidget;
    obbligatorio?: boolean;
    q?: string;
}



